let config = {};

const env = process.env.REACT_APP_ENV;
// eslint-disable-next-line
console.log('@@@@@@ loading config for env:', env);

switch (env) {
  case 'development':
    config = {
      apiHost: 'http://localhost:4000',
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignTemplateTypesPurposes: '/v1/campaign-templates/type',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms'
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free'
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A'
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS'
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ['premium-invalid'],
            planId: 'premium',
            amount: 399
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premiumAnnually: {
            planId: 'premium-annually',
            amount: 2988
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388
          }
        }
      },
      GoogleAuth: {
        clientId: '271699968826-o9prronf2ted8j5ve4nn4bi2valkoq6o.apps.googleusercontent.com'
      },
      AWS: {
        SiteAssets: 'https://s3.amazonaws.com/videopeel-development',
        cdnUrl: `https://${process.env.OUTPUT_BUCKET}.s3.amazonaws.com`,
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl:
          process.env.FILE_UPLOAD_URL ||
          'https://ley3aeio81.execute-api.us-east-1.amazonaws.com/dev/files',
        attachmentsCloudfrontUrl:
          process.env.CLOUDFRONT_URL || 'https://d111yeai6xpcar.cloudfront.net',
        S3bucketName: process.env.OUTPUT_BUCKET
      },
      FACEBOOK: {
        isEnabled: false, // V2-425 needs to be false for unit tests :grimacing:
        appId: '2457067157728402'
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: `https://${process.env.OUTPUT_BUCKET}.s3.amazonaws.com`,
      baseAppDomain: '', // do not add anything here for development env, otherwise redirect rules for custom domains will start applying
      subdomainBaseUrl: '',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false
    };
    break;

  case 'staging':
    config = {
      apiHost: 'https://stagingapi.videopeel.com',
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms'
      },
      stripe: {
        stripeKey: 'pk_test_e4q7MWpjoYvVfclU3T7DvEmX',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free'
          },
          basicMonthly: {
            planId: 'price_1Mvi2gGddCycc7Zp51VoXF6A'
          },
          basicAnnually: {
            planId: 'price_1Mvi2gGddCycc7Zpabq9bfWS'
          },
          pro: {
            planId: 'pro',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premium: {
            // Used to reproduce https://videopeel.atlassian.net/browse/V2-260
            oldPlansId: ['premium-invalid'],
            planId: 'premium',
            amount: 399
          },
          enterprise: {
            planId: 'enterprise',
            amount: 1000
          },
          proAnnually: {
            planId: 'pro-annually',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premiumAnnually: {
            planId: 'premium-annually',
            amount: 2988
          },
          enterpriseAnnually: {
            planId: 'enterprise-annually',
            amount: 10000
          },
          enterpriseMonthly: {
            planId: 'enterprise-monthly',
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: 'price_1H2rZ0GddCycc7ZpodlEwUwa',
            amount: 69,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonBasicAnnual: {
            planId: 'price_1H2raJGddCycc7ZpqfOpsGYu',
            amount: 588,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2raqGddCycc7ZpYcJIat72',
            amount: 249
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2rbKGddCycc7Zp87Gy3ov8',
            amount: 2388
          }
        }
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com'
      },
      AWS: {
        SiteAssets: 'https://d21kaqp8o0oh0c.cloudfront.net',
        cdnUrl: 'https://d21kaqp8o0oh0c.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-development',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/stage/process-video',
        fileUploadUrl: 'https://u2ipod3vsf.execute-api.us-east-1.amazonaws.com/staging/files',
        attachmentsCloudfrontUrl: 'https://d3rn0qvp5ksu2g.cloudfront.net',
        S3bucketName: 'videopeel-development'
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '2457067157728402'
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: false,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://pluginstaging.videopeel.com',
      baseAppDomain: 'staging.videopeel.com',
      subdomainBaseUrl: 'staging.videopeel.com',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-3',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      contactSalesLink: 'https://www.videopeel.com',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: false,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false
    };
    break;

  case 'production':
    config = {
      apiHost: 'https://api.videopeel.com',
      endpoints: {
        fileTypes: '/v1/options/file-types',
        publicCampaignInfo: '/v1/campaigns/',
        preSignVideoForS3: '/videos/s3/sign',
        campaignCount: '/campaign/count',
        campaignElementTypes: '/v1/campaigns/element-types',
        campaignSubmissions: '/v1/campaign-submissions',
        campaignResponseKeys: '/v1/campaign-response-keys',
        campaignList: '/v1/campaigns',
        campaignTemplateTypes: '/v1/campaign-templates',
        campaignCreate: '/v1/campaigns',
        campaignDuplicate: '/v1/campaigns/duplicate',
        campaignDownloadResponsesCsv: '/v1/campaign-submissions/campaign',
        media: '/v1/media',
        amazonShare: '/videos/amazon',
        amazonShareStatus: '/v1/media',
        tags: '/v1/tags',
        preSignCampaignElementImageForS3: '/v1/campaign-elements/image/presign',
        authSso: '/organizations/sso',
        createPlugin: '/v1/plugins',
        pluginDetails: '/v1/plugins',
        preSignCepMediaSubmission: '/v1/media-submissions/cep',
        campaignSuccessPageEndpoint: '/v1/campaigns/success-page',
        terms: '/v1/terms'
      },
      stripe: {
        stripeKey:
          'pk_live_51BM0KYGddCycc7ZpiQdMQxnF5jyMOz6UfPf8oWrRsWeCjuGLxPC5HlI0M05ZVPEWEOmd2g6OL9GnJNbsQBGAC5eW00uclHL9Xy',
        name: 'VideoPeel', // the pop-in header title
        description: 'VideoPeel subscription payment', // the pop-in header subtitle
        buttonText: 'Sign Up',
        currency: 'USD',
        plans: {
          basic: {
            planId: 'free'
          },
          basicMonthly: {
            planId: 'price_1Mw1C3GddCycc7Zp9KjTNRaI'
          },
          basicAnnually: {
            planId: 'price_1N8WdpGddCycc7Zp4uUDj8Wk'
          },
          pro: {
            oldPlansId: ['plan_Eo9RGo1vW6jr5x'],
            planId: 'plan_GcgUejNNXClIwi',
            amount: 69,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premium: {
            oldPlansId: ['plan_GcgYRz69NITi3X', 'plan_FHjyi8YjF6DOTL'],
            planId: 'plan_H3dvqapPNg3rYY',
            amount: 399
          },
          enterprise: {
            planId: 'plan_H3e1Q7cBYJZp0z',
            amount: 1000
          },
          proAnnually: {
            planId: 'plan_H3e9KsEYNAzD1K',
            amount: 588,
            perMonthVideo: {
              limit: 10,
              debut: '2020-11-24 00:00:00'
            }
          },
          premiumAnnually: {
            planId: 'plan_H3eCryd5JCaxgE',
            amount: 2988
          },
          enterpriseAnnually: {
            planId: 'plan_H3eLFlACpGpOnb',
            amount: 10000
          },
          enterpriseMonthly: {
            planId: 'price_1HJmgnGddCycc7ZpXc3w39r9',
            amount: 2000
          },
          amazonBasicMonthly: {
            planId: 'price_1H2r02GddCycc7ZpEoeJBhGu',
            amount: 69,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonBasicAnnual: {
            planId: 'price_1H2r2jGddCycc7ZpwTmAvvzm',
            amount: 588,
            perMonthVideo: {
              limit: 25
            }
          },
          amazonPremiumMonthly: {
            planId: 'price_1H2r3qGddCycc7ZpPdUIMciS',
            amount: 249
          },
          amazonPremiumAnnual: {
            planId: 'price_1H2r56GddCycc7Zp0JXIpJTX',
            amount: 2388
          }
        }
      },
      GoogleAuth: {
        clientId: '271699968826-n516e2dad90ll393c7v5o25q740t8j6l.apps.googleusercontent.com'
      },
      AWS: {
        SiteAssets: 'https://d2fr8icwxgw12b.cloudfront.net',
        cdnUrl: 'https://d2fr8icwxgw12b.cloudfront.net',
        S3bucket: 'https://s3.amazonaws.com/videopeel-production',
        GateWayURL: 'https://srfukq2ekd.execute-api.us-east-1.amazonaws.com/prod/process-video',
        fileUploadUrl: 'https://gd4215x8y7.execute-api.us-east-1.amazonaws.com/prod/files',
        attachmentsCloudfrontUrl: 'https://d3pxzwt5386y7s.cloudfront.net',
        S3bucketName: 'videopeel-production'
      },
      FACEBOOK: {
        isEnabled: true,
        appId: '454904778263732'
      },
      trialPeriod: {
        days: 7
      },
      projectId: 257755,
      projectKey: '913f712f693843d510f39b4293af316f',
      VideoPeelSupportLink: 'https://calendly.com/derek-217/vp-account-update',
      campaignIDs: ['k64bbg52', 'k7dmg3hc', 'k7dop0ti'],
      intercomAppID: 'uhfhkkts',
      campaignLimit: 2,
      errorBoundary: true,
      startVideoLink: 'https://www.youtube.com/embed/m5E9Q5cdD6E',
      pluginURL: 'https://plugin.videopeel.com',
      baseAppDomain: 'app.videopeel.com',
      subdomainBaseUrl: 'videopeel.com',
      perMonthVideo: 50,
      googleAnalyticsId: 'UA-112744776-2',
      nextGenMinimalCampaignTypeEnabled: true,
      mediaRecordsPerPageDefault: 25,
      campaignRecordsPerPageDefault: 25,
      maxCampaignsPerAccount: 50,
      pluginsV2Enabled: true,
      signInV2Enabled: true,
      pluginFontSizeEnabled: false,
      promoCodeEnabled: true,
      helpCenterLink: 'https://learn.videopeel.com/en/',
      contactSalesLink: 'https://meetings.hubspot.com/nico110',
      openMediaInPreviewModal: true,
      isAwinTrackingEnabled: true,
      vcpLiveExampleLink: 'https://app.videopeel.com/vc/cdtgx88l',
      vcpShareEnabled: false
    };
    break;
  default:
    throw new Error(`Missing or unsupported REACT_APP_ENV enviroment variable: ${env}`);
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js